import { Controller } from "@hotwired/stimulus";
import Cookies from "js-cookie";

const COOKIE_NAME = "massimo_tool_debug";

export default class extends Controller {
  connect() {
    this.element.dataset.toolDebug = Cookies.get(COOKIE_NAME) !== "false";
  }

  toggle({ target }) {
    const enabled = target.checked;
    Cookies.set(COOKIE_NAME, enabled, { path: "/", expires: 365, sameSite: "Lax" });
    this.element.dataset.toolDebug = enabled;
    target.blur();
  }
}
